<template>
	<div
		class="relative"
		:class="{
			'h-2 rounded-xs bg-black p-0.5': color === 'yellow',
			'bg-fill-secondary h-1': color === 'secondary'
		}"
	>
		<div
			class="absolute border-r-2 border-black"
			:style="{ width: `${value * 100}%`, minWidth: '5px' }"
			:class="{
				'bg-yellow top-0.5 bottom-0.5 left-0.5': color === 'yellow',
				'bg-label-secondary top-0 bottom-0 left-0': color === 'secondary'
			}"
		/>
	</div>
</template>
<script setup lang="ts">
import { sleep } from '@/utils/sleep'
import { ref } from 'vue'

defineProps<{
	value: number
	color: 'yellow' | 'secondary'
}>()

const loaded = ref(false)

const onLoad = async () => {
	await sleep(100)
	loaded.value = true
}

onLoad()
</script>
